import PropTypes from "prop-types";
import Image from "next/legacy/image";

import { PROFILE_TYPES } from "../../constants";

function ProfileType({ type, onClick }) {
  const { img, text } =
    type === PROFILE_TYPES.CLASSROOM
      ? {
          img: "/classroom-user-registration.png",
          text: "At a School",
        }
      : {
          img: "/home-user-registration.png",
          text: "At Home",
        };

  return (
    <div className="flex flex-col">
      <div
        onClick={() => onClick(type)}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            onClick(type);
          }
        }}
        role="button"
        tabIndex={0}
        className="cursor-pointer aspect-w-2 aspect-h-1"
      >
        <Image
          unoptimized
          layout="fill"
          priority
          alt={`${text} option`}
          src={img}
        />
      </div>
      <p className="text-lg font-bold text-white self-center mt-md">{text}</p>
    </div>
  );
}

ProfileType.propTypes = {
  type: PropTypes.oneOf([PROFILE_TYPES.CLASSROOM, PROFILE_TYPES.KID_HOME])
    .isRequired,
  onClick: PropTypes.func,
};

ProfileType.defaultProps = {
  onClick: () => {},
};

export default ProfileType;
